// extracted by mini-css-extract-plugin
export default {"ad-banner":"ad-banner--mp-GXh8Q","adBanner":"ad-banner--mp-GXh8Q"};